'use strict';

var keys = require('./keys.js');
var makeNonNullableArray = require('./makeNonNullableArray.js');

/**
 * Omit non-empty types from an array of elements.
 *
 * @template T - The type of the elements in the array.
 * @param els - The array of elements to filter.
 * @returns An array of elements with non-empty types omitted.
 */ function excludeEmptyTypedElements(els) {
    return makeNonNullableArray(els).filter((el)=>{
        return keys(el).find((key)=>key !== '__typename');
    });
}

module.exports = excludeEmptyTypedElements;
